import React, { useMemo } from 'react';
import './TopUsersChart.css';

const TopUsersChart = ({ users = [], totalActivities, onUserSelect, selectedUserId, searchQuery = '' }) => {
  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return users;
    return users.filter((u) => {
      const name = (u.username     || '').toLowerCase();
      const email = (u.email       || '').toLowerCase();
      const org  = (u.organization || u.organisation || u.org || u.group || '').toLowerCase();
      return name.includes(q) || email.includes(q) || org.includes(q);
    });
  }, [users, searchQuery]);

  if (!users.length) return <div className="tuc-empty">Aucun utilisateur</div>;

  if (filtered.length === 0) {
    return <div className="tuc-empty">Aucun résultat pour «&nbsp;{searchQuery}&nbsp;»</div>;
  }

  return (
    <ul className="tuc-list">
      {filtered.map((user, idx) => {
        const count      = user.activity_count || user.total_activities || 0;
        const pct        = totalActivities > 0 ? ((count / totalActivities) * 100).toFixed(1) : 0;
        const isSelected = selectedUserId != null && selectedUserId === user.user_id;
        const name       = user.username || `User ${user.user_id}`;
        const initials   = name.slice(0, 2).toUpperCase();
        const email      = user.email || null;
        const org        = user.organization || user.organisation || user.org || user.group || null;
        const rank       = users.findIndex((u) => u.user_id === user.user_id) + 1;

        return (
          <li
            key={user.user_id ?? idx}
            className={`tuc-card${isSelected ? ' tuc-card--active' : ''}`}
            onClick={() => onUserSelect(user.user_id)}
          >
            <div className="tuc-avatar">
              <span className="tuc-initials">{initials}</span>
            </div>

            <div className="tuc-identity">
              <div className="tuc-name-line">
                <span className="tuc-rank">#{rank}</span>
                <span className="tuc-name">{name}</span>
              </div>
              {email && <span className="tuc-email">{email}</span>}
            </div>

            <div className="tuc-sep" />

            <div className="tuc-org-col">
              {org
                ? <>
                    <span className="tuc-field-label">org.</span>
                    <span className="tuc-org-val">{org}</span>
                  </>
                : <span className="tuc-org-empty">—</span>
              }
            </div>

            <div className="tuc-sep" />

            <div className="tuc-right">
              <div className="tuc-status-col">
                <span className={`tuc-badge ${user.active ? 'tuc-badge--on' : 'tuc-badge--off'}`}>
                  <span className="tuc-dot" />
                  {user.active ? 'Actif' : 'Inactif'}
                </span>
              </div>
              <div className="tuc-sep" />
              <div className="tuc-stats">
                <span className="tuc-count">{count.toLocaleString()}</span>
                <span className="tuc-pct">{pct}%</span>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default TopUsersChart;